import { useNavigate } from "@tanstack/react-router";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import FeedbackView from "./FeedbackView";

/**
 * Chi tiết phiếu phản hồi dạng popup trên trang danh sách (/feedback/$feedbackId).
 * Desktop: hộp giữa màn hình (tối đa max-w-5xl, cuộn bên trong); mobile: phủ toàn màn hình.
 * Đóng (X, Esc, bấm ra ngoài) quay về /feedback, giữ nguyên bộ lọc/tìm kiếm.
 */
export default function FeedbackDetailModal({ feedbackId }: { feedbackId: string }) {
  const navigate = useNavigate();
  const close = () => navigate({ to: "/feedback", search: (prev: any) => prev } as any);

  return (
    <Dialog open onOpenChange={(open) => !open && close()}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        data-testid="fb-detail-modal"
        className="block p-0 gap-0 bg-slate-50 overflow-y-auto overscroll-contain md:max-w-5xl md:max-h-[90vh] max-md:inset-0 max-md:top-0 max-md:left-0 max-md:translate-x-0 max-md:translate-y-0 max-md:max-w-none max-md:h-[100dvh] max-md:rounded-none max-md:border-0"
      >
        <DialogTitle className="sr-only">Chi tiết phản hồi</DialogTitle>
        <FeedbackView feedbackId={feedbackId} variant="modal" onClose={close} />
      </DialogContent>
    </Dialog>
  );
}
